export enum TypeOfConsideration {
    CashAtClose = 0,
    DeferredFixedPayments = 1,
    DeferredVariablePayments = 2,
    Earnout = 3,
    SyntheticJvEquity = 4,
    JvEquity = 5,
    CorporateEquity = 6,
    Other = 7,
    PreferredEquity = 8,
    CommonEquity = 9,
}

export const HEADER_ONLY_CONSIDERATION_TYPES: ReadonlySet<TypeOfConsideration> = new Set([
    TypeOfConsideration.DeferredVariablePayments,
    TypeOfConsideration.CorporateEquity,
]);

export const isHeaderOnlyConsiderationType = (type: TypeOfConsideration): boolean =>
    HEADER_ONLY_CONSIDERATION_TYPES.has(type);

export const TypesOfConsideration = [
    {
        id: TypeOfConsideration.CashAtClose,
        name: 'Cash at Close',
    },
    {
        id: TypeOfConsideration.DeferredFixedPayments,
        name: 'Deferred Fixed Payments',
    },
    {
        id: TypeOfConsideration.DeferredVariablePayments,
        name: 'Deferred Variable Payments',
    },
    {
        id: TypeOfConsideration.Earnout,
        name: 'Earnout',
    },
    {
        id: TypeOfConsideration.SyntheticJvEquity,
        name: 'Synthetic JV Equity',
    },
    {
        id: TypeOfConsideration.JvEquity,
        name: 'JV Equity',
    },
    {
        id: TypeOfConsideration.CorporateEquity,
        name: 'Corporate Equity',
    },
    {
        id: TypeOfConsideration.CommonEquity,
        name: 'Common Corp Equity',
    },
    {
        id: TypeOfConsideration.PreferredEquity,
        name: 'Preferred Corp Equity',
    },
    {
        id: TypeOfConsideration.Other,
        name: 'Other',
    },
];
